import { useContext, useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { NavigationLink } from "../setup"
import { playerLinks } from "../../../entries"
import { PermissionContext } from "../../../contexts/PermissionContexts"
import { useTranslation } from "react-i18next"
import { BreadCrumbsGeneral } from "../../../components/NavigationComponents"


export const MembersPage = () => {
    const { t } = useTranslation('settings')
    const { hasPermission } = useContext(PermissionContext)
    const navigator = useNavigate()
    const location = useLocation()
    const [showSwitch, setShowSwitch] = useState(false)

    const [breadCrumbs, setBreadCrumbs] = useState(
        [
            {
                link: "/admin/dashboard",
                name: t("Home")
            },
            {
                link: "/admin/members",
                name: t("Players", { ns: 'sidebar' })
            },
            {
                link: null,
                name: t('Search Players')
            }
        ]
    )

    useEffect(() => {
        if (location.pathname === "/admin/members" || location.pathname === "/admin/members/") {
            navigator("/admin/members/search-members")
        }
        else if (location.pathname.startsWith("/admin/members/")) {
            // navigator("")
        }

        if (location.pathname.startsWith("/admin/members/member-profile")) {
            setShowSwitch(false)

        }
        else {
            setShowSwitch(true)
        }

        Object.values(playerLinks).forEach((link) => {
            if (location.pathname.split("/")[location.pathname.split("/").length - 1] === link.link) {
                getTitle(t(link.title));
            }
        })
    }, [location])


    const getTitle = (title) => {
        setBreadCrumbs((prev) => {
            prev.pop()
            return [...prev, {
                link: null,
                name: title
            }]
        })
    }

    return (
        <>

            {
                showSwitch &&
                <div className="grid grid-cols-3 w-full px-4 py-2">
                    <div className="flex flex-col">
                        <span className="text-xl font-semibold">{t('Players', { ns: 'sidebar' })}</span>
                        <BreadCrumbsGeneral elements={breadCrumbs} />
                    </div>
                    <div className="justify-self-center w-80 max-w-max flex flex-col join join-horizontal shadow-md">
                        {
                            playerLinks.map((link, index) =>
                                hasPermission(link.permission) &&
                                <NavigationLink key={index} props={link} getTitle={getTitle} />
                            )
                        }
                    </div>
                </div>
            }
            <Outlet />
        </>
    )
}